/* __next_internal_client_entry_do_not_use__ Checkmark auto */ import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { createSVGIcon } from "../util";
/**
 * @deprecated use Check from foundation/Check
 * @trackcomponent
 */ export var Checkmark = createSVGIcon(/*#__PURE__*/ _jsx("path", {
    d: "M6.08714 10.4652L4.01611 8.25765C3.78335 8.00954 3.40734 8.00954 3.17457 8.25765C2.94181 8.50576 2.94181 8.90656 3.17457 9.15467L5.66935 11.8139C5.90212 12.062 6.27813 12.062 6.51089 11.8139L12.8254 5.0831C13.0582 4.83499 13.0582 4.43419 12.8254 4.18608C12.5927 3.93797 12.2167 3.93797 11.9839 4.18608L6.08714 10.4652Z",
    fill: "currentColor"
}), "Checkmark", {
    viewBox: "0 0 16 16",
    titleAccess: "Checkmark",
    strokeWidth: 1.5
});
